import { render } from "./TeamTab.vue?vue&type=template&id=c2d32100"
import script from "./TeamTab.vue?vue&type=script&lang=js"
export * from "./TeamTab.vue?vue&type=script&lang=js"

import "./TeamTab.vue?vue&type=style&index=0&id=c2d32100&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__